import { Extension } from '@tiptap/core';

export const textIndentExtension = Extension.create({
  name: 'textIndent',

  addGlobalAttributes() {
    return [
      {
        types: ['paragraph', 'heading'],
        attributes: {
          indentLevel: {
            default: 0,
            parseHTML: (element: HTMLElement): number => {
              const style = element.getAttribute('style');
              const match = style?.match(/padding-left:\s*(\d+(?:\.\d+)?)em/);
              return match ? Math.round(parseFloat(match[1]) / 3) : 0; // 3em = 1 niveau
            },
            renderHTML: (attributes: { indentLevel?: number }): Record<string, string> => {
              if (!attributes.indentLevel || attributes.indentLevel === 0) {
                return {};
              }
              return {
                style: `padding-left: ${attributes.indentLevel * 3}em`,
              };
            },
          },
        },
      },
    ];
  },
});
